module.exports = __webpack_public_path__ + "static/media/menu.e6b3a03b.svg";